import $ from 'jquery';

(function ($, document, window, undefined) {
  'use strict';

  let pluginName = 'ebcontactform';
  let $element;

  let defaults = {
    color: '#d0a658;',
    disabled: false,
    title: 'Contact Form',
    onUpdate: function (value) {},
  };

  class Plugin {
    constructor(element, options) {
      this.element = element;

      this.settings = $.extend({}, defaults, options);
      this.useCustomEmotions = false;

      this.$el = $(element);
      this.$el.data(element.name, this);

      this._defaults = defaults;
      this._name = pluginName;

      let meta = this.$el.data(name + '-opts');
      this.opts = $.extend(this._defaults, options, meta);

      this.containerCode = this.$el.attr('id');
      this.elementContainer = $(element);

      this.clicked = [];
      this.clicked[this.containerCode] = false;

      this.init();
    }

    init() {
      $element = $(this.element);
      this.count = 0;
      this.renderComponent();
      this.setEventHandler();
    }

    renderComponent() {
      let container = "<div class='" + this.containerCode + "'>";
      let emotionDiv;

      emotionDiv = `<div class="container">
                      <form  class="formContact" >
                      <div>
                        <label for="inputName" >Name:</label>
                        <input name="inputName" id="sq_221" type="text"  placeholder="Name:" class="sv-text-form-contact" />
                      </div>

                      <div>
                        <label for="inputEmail" >E-mail:</label>
                        <input name="inputEmail" id="inputEmail" type="text"  placeholder="E-mail:" class="sv-text-form-contact" />
                      </div>

                      <div>
                        <label for="inputPhoneNumber" >Telefon:</label>
                        <input name="inputPhoneNumber" id="sq_223" type="text"  placeholder="Telefon:" class="sv-text-form-contact" />
                      </div>



                      <div>
                        <input name="inputUserAnswer" id="sq_225" type="hidden" class="sv-text-form-contact" />
                        <input name="inputCode" id="sq_220" type="hidden" class="sv-text-form-contact" />
                      </div>


                      <div class="how-and-when-contact">
                        <div class="checkbox-group-div">
                          <label >Wie dürfen wir Sie kontaktieren?</label>
                          <input name="checkbox-email" id="sq_226" type="checkbox"  class="sv-checkbox-form-contact">per E-Mail</input> </br>
                          <input name="checkbox-phone" id="sq_227" type="checkbox"  class="sv-checkbox-form-contact">telefonisch</input> </br>
                          <div>
                            <input name="checkbox-other" id="sq_228" type="checkbox"  class="sv-checkbox-form-contact">sonstiges, nämlich: </input>
                            <input name="inputOther" id="sq_229" type="text"  placeholder="" class="sv-text-form-contact" />
                          </div>
                          </div>


                        <div class="checkbox-group-div">
                          <label >Wann können wir Sie am besten telefonisch erreichen?</label>
                          <input name="checkbox-vormittags" id="sq_230" type="checkbox"  class="sv-checkbox-form-contact">vormittags</input> </br>
                          <input name="checkbox-mittags" id="sq_231" type="checkbox"  class="sv-checkbox-form-contact">mittags</input> </br>
                          <input name="checkbox-nachmittags" id="sq_232" type="checkbox"  class="sv-checkbox-form-contact">nachmittags</input>
                        </div>
                      </div>

                      <div class="checkbox-div-accept-terms">
                        <input name="checkbox-accept-terms" id="cls-checkbox-accept-terms" type="checkbox"  class="checkbox-accept-terms">Ich willige hiermit ein, dass meine Kontaktinformationen gespeichert und für die Kontaktaufnahme durch meine Bank genutzt werden (<u><a href="https://www.emotion-banking.at/datenschutz/" target=”_blank” >Informationen zum Datenschutz</a></u>).</input> </br>
                      </div>

                      <div class="button-send">
                        <button type="submit" id="btn-send-mail" class="sv-btn-contact-form" disabled="true">Kontaktinformationen senden</button>
                      </div>
                    </form>
                  </div>`;
      container += emotionDiv;
      container += '</div>';
      $element.append(container);
      if (this.settings.initialRating > 0) {
        this.initalRate(this.settings.initialRating);
      }
    }

    setEventHandler() {
      let self = this;

      const mailTo = this.settings.question.propertyHash.mailTo;
      const mailFrom = this.settings.question.propertyHash.mailFrom;
      self.elementContainer.on(
        {
          submit: function (ev) {
            ev.preventDefault();
            const value = ev;
            const inputMail = document.getElementById('inputEmail');
            ev.preventDefault();

            if (!inputMail.value) {
              alert('Bitte geben Sie Ihre E-Mail-Adresse ein.');
              return;
            }

            const data = {
              to: `${mailTo}`,
              from: `${mailFrom}`,
              subject: `Kontaktinformationen - ${
                ev.target['inputCode']?.value ?? 'No Code'
              }`,
              html: `<p>Mit der Bitte um Kontaktaufnahme.</p>
                  <p>
                    Name: ${ev.target['inputName'].value}<br/>
                    E-Mail: ${ev.target['inputEmail'].value}<br/>
                    Telefon: ${ev.target['inputPhoneNumber'].value}<br/>
                    Erreichbarkeit: ${
                      ev.target['checkbox-vormittags'].checked
                        ? `* vormittags`
                        : ``
                    } ${
                ev.target['checkbox-mittags'].checked ? `* mittags` : ``
              }  ${
                ev.target['checkbox-nachmittags'].checked ? `* nachmittags` : ``
              }  <br/>
                    Grund der Kontaktaufnahme: ${
                      ev.target['inputUserAnswer'].value
                    }<br/>
                    Kontaktmöglichkeit: ${
                      ev.target['checkbox-phone'].checked ? `* Telefon` : ``
                    } ${
                ev.target['checkbox-email'].checked ? `* E-Mail` : ``
              } ${
                ev.target['checkbox-other'].checked
                  ? `* sonstiges: ${ev.target['inputOther'].value}`
                  : ``
              } <br/>
                  </p>
            `,
            };

            const url = `${process.env.REACT_APP_API_URL}/sendMail`;

            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            })
              .then(response => response.json())
              .then(data => {
                alert('Informationen gesendet.');
                const button = document.getElementById('btn-send-mail');
                button.disabled = true;
              })
              .catch(error => {
                console.error('Ocorreu um erro:', error);
              });
          },
        },
        '.formContact',
      );

      self.elementContainer.on(
        {
          change: function (ev) {
            const currentUrl = window.location.href;

            const button = document.getElementById('btn-send-mail');
            const inputMail = document.getElementById('inputEmail');

            if (ev.target.checked) {
              button.disabled = false;
            } else {
              button.disabled = true;
            }
          },
        },
        '.checkbox-accept-terms',
      );
    }

    initalRate(count) {
      let self = this;
      self.showEmotion(count);
    }

    updateInput(count) {
      let self = this;
      let _input = self.elementContainer.find('#selectedItem');
      _input.val(count);
    }
  }

  $.extend();

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });
  };
})($, document, window);
